import { render, staticRenderFns } from "./ItemListDropdown.vue?vue&type=template&id=0b142d68&scoped=true"
import script from "./ItemListDropdown.vue?vue&type=script&lang=js"
export * from "./ItemListDropdown.vue?vue&type=script&lang=js"
import style0 from "./ItemListDropdown.vue?vue&type=style&index=0&id=0b142d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b142d68",
  null
  
)

export default component.exports